// https://auth-server-qa-butler.gccmex.io/en/admin/auth/permission/?q=APP-7NOWMANAGER-%2F
export const permissions = {
    'APP-7NOWMANAGER-STORE-READ': 'APP-7NOWMANAGER-STORE-READ',
    'APP-7NOWMANAGER-ORDER-READ': 'APP-7NOWMANAGER-ORDER-READ',

    'APP-7NOWMANAGER-PROMOTION-READ': 'APP-7NOWMANAGER-PROMOTION-READ',
    'APP-7NOWMANAGER-PROMOTION-WRITE': 'APP-7NOWMANAGER-PROMOTION-WRITE',
    'APP-7NOWMANAGER-PROMOTION-PUBLISH': 'APP-7NOWMANAGER-PROMOTION-PUBLISH',

    'APP-7NOWMANAGER-NOTIFICATION-READ': 'APP-7NOWMANAGER-NOTIFICATION-READ',
    'APP-7NOWMANAGER-NOTIFICATION-WRITE': 'APP-7NOWMANAGER-NOTIFICATION-WRITE',
    'APP-7NOWMANAGER-NOTIFICATION-PUBLISH': 'APP-7NOWMANAGER-NOTIFICATION-PUBLISH',

    'APP-7NOWMANAGER-STOREIMPORT-READ': 'APP-7NOWMANAGER-STOREIMPORT-READ',
    'APP-7NOWMANAGER-STOREIMPORT-WRITE': 'APP-7NOWMANAGER-STOREIMPORT-WRITE',
    'APP-7NOWMANAGER-STOREIMPORT-SYNC': 'APP-7NOWMANAGER-STOREIMPORT-SYNC',
    'APP-7NOWMANAGER-PRODUCTIMPORT-READ': 'APP-7NOWMANAGER-PRODUCTIMPORT-READ',
    'APP-7NOWMANAGER-PRODUCTIMPORT-WRITE': 'APP-7NOWMANAGER-PRODUCTIMPORT-WRITE',
    'APP-7NOWMANAGER-PRODUCTIMPORT-SYNC': 'APP-7NOWMANAGER-PRODUCTIMPORT-SYNC',
    'APP-7NOWMANAGER-INVENTORYIMPORT-READ': 'APP-7NOWMANAGER-INVENTORYIMPORT-READ',
    'APP-7NOWMANAGER-INVENTORYIMPORT-WRITE': 'APP-7NOWMANAGER-INVENTORYIMPORT-WRITE',
    'APP-7NOWMANAGER-INVENTORYIMPORT-SYNC': 'APP-7NOWMANAGER-INVENTORYIMPORT-SYNC',

    'APP-7NOWMANAGER-PRODUCT-READ': 'APP-7NOWMANAGER-PRODUCT-READ',
    'APP-7NOWMANAGER-PRODUCT-WRITE': 'APP-7NOWMANAGER-PRODUCT-WRITE',
}
